import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "preview",
    "fg",
    "bg",
    "rounded",
    "radius",
    "size",
    "embed",
    "downloadSvg",
    "downloadPng",
    "customization"
  ];

  connect() {
    this.update();
    // Hide customization panel by default
    if (this.hasCustomizationTarget) {
      this.hideCustomization();
    }
  }

  update() {
    const params = this.params();
    const base = this.basePath();
    const url = `${base}.svg?${params}`;
    this.previewTarget.src = url;
    // Also mirror values into hidden fields in the form so Save persists them
    const form = document.querySelector('form.profile-form__form');
    if (form) {
      const fg = form.querySelector('input[name="user[qr_fg]"]');
      const bg = form.querySelector('input[name="user[qr_bg]"]');
      const size = form.querySelector('input[name="user[qr_size]"]');
      const rounded = form.querySelector('input[type="checkbox"][name="user[qr_rounded]"]');
      const radius = form.querySelector('input[name="user[qr_radius]"]');
      const embed = form.querySelector('input[type="checkbox"][name="user[qr_embed_avatar]"]');
      if (fg) fg.value = this.fgTarget.value;
      if (bg) bg.value = this.bgTarget.value;
      if (size) size.value = parseInt(this.sizeTarget.value, 10) || 200;
      if (rounded) rounded.checked = this.roundedTarget.checked;
      if (radius) radius.value = this.roundedTarget.checked ? (parseFloat(this.radiusTarget.value) || 0) : '';
      if (embed && this.hasEmbedTarget) embed.checked = this.embedTarget.checked;
    }
    this.downloadSvgTarget.href = `${this.downloadBasePath()}.svg?${params}`;
    this.downloadPngTarget.href = `${this.downloadBasePath()}.png?${params}`;
  }

  showCustomization() {
    if (!this.hasCustomizationTarget) return;
    this.customizationTarget.style.display = "block";
  }

  hideCustomization() {
    if (!this.hasCustomizationTarget) return;
    this.customizationTarget.style.display = "none";
  }

  toggleCustomization() {
    if (!this.hasCustomizationTarget) return;
    const isHidden = this.customizationTarget.style.display === "none" || getComputedStyle(this.customizationTarget).display === "none";
    if (isHidden) {
      this.showCustomization();
    } else {
      this.hideCustomization();
    }
  }

  save() {
    // Mirror current values to hidden inputs, then submit the main form
    this.update();
    const form = document.querySelector('form.profile-form__form');
    if (form) {
      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit();
      } else {
        form.submit();
      }
    }
  }

  params() {
    const p = new URLSearchParams();
    const size = parseInt(this.sizeTarget.value, 10) || 200;
    p.set("size", size);

    const fg = (this.fgTarget.value || "").replace(/^#/, "");
    if (fg) p.set("fg", fg);
    const bg = (this.bgTarget.value || "").replace(/^#/, "");
    if (bg) p.set("bg", bg);

    if (this.roundedTarget.checked) {
      p.set("rounded", "true");
      p.set("radius", 10);
    }
    if (this.hasEmbedTarget && this.embedTarget.checked) {
      p.set("embed_avatar", "true");
    }
    return p.toString();
  }

  basePath() {
    // expects data-base-path to be set to qr_code_home_profile_path without format
    return this.element.dataset.basePath;
  }

  downloadBasePath() {
    // expects data-download-base-path to be set to download_qr_code_home_profile_path without format
    return this.element.dataset.downloadBasePath;
  }
}


